import { render, staticRenderFns } from "./ResumeInfo.vue?vue&type=template&id=40afcca4&scoped=true"
import script from "./ResumeInfo.vue?vue&type=script&lang=js"
export * from "./ResumeInfo.vue?vue&type=script&lang=js"
import style0 from "./ResumeInfo.vue?vue&type=style&index=0&id=40afcca4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40afcca4",
  null
  
)

export default component.exports